module.exports = __webpack_public_path__ + "img/5.be05cb09.jpg";